/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsVerifyPayments200,
  PostApiV1IndividualpaymentParcelsVerifyPayments401,
  PostApiV1IndividualpaymentParcelsVerifyPayments500,
  PostApiV1IndividualpaymentParcelsVerifyPaymentsMutationRequest,
  PostApiV1IndividualpaymentParcelsVerifyPaymentsMutationResponse,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsVerifyPayments.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsVerifyPayments200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsVerifyPayments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsVerifyPayments401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsVerifyPayments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsVerifyPayments500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsVerifyPayments500>;

export const postApiV1IndividualpaymentParcelsVerifyPaymentsMutationRequestSchema =
  z.array(
    z.number().int(),
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsVerifyPaymentsMutationRequest>;

export const postApiV1IndividualpaymentParcelsVerifyPaymentsMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsVerifyPayments200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsVerifyPaymentsMutationResponse>;
